import { isDefined } from '@morpho-org/morpho-ts'

import { getMarketActionError } from '@/hooks/operation/market/v2/marketActionError'

interface LendWithdrawErrorMessageParams {
  isWithdrawOverMax: boolean
  isLiquidityCapped: boolean
  reallocationError: Error | undefined
  localLiquidity: bigint | undefined
  inputWithdrawAmount: bigint
  isEmpty: boolean
  isDebouncing: boolean
  buildError: unknown
}

export const getLendWithdrawErrorMessage = ({
  isWithdrawOverMax,
  isLiquidityCapped,
  reallocationError,
  localLiquidity,
  inputWithdrawAmount,
  isEmpty,
  isDebouncing,
  buildError
}: LendWithdrawErrorMessageParams) => {
  // Shared-liquidity failures take precedence over the conservative local cap.
  if (reallocationError && isDefined(localLiquidity) && inputWithdrawAmount > localLiquidity)
    return 'Shared liquidity is unavailable, reduce the amount or try again'
  if (isWithdrawOverMax)
    return isLiquidityCapped ? 'Not enough liquidity available' : 'Amount exceeds your position'
  return isEmpty || isDebouncing ? undefined : getMarketActionError({ buildError })
}

export const shouldShowLendWithdrawLiquidityWarning = ({
  isLiquidityCapped,
  reallocationError
}: {
  isLiquidityCapped: boolean
  reallocationError: Error | undefined
}) => isLiquidityCapped && !reallocationError
